import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import { TeamData, TeamMemberDataPost } from '@interfaces/Team.interface';

export class ApiTeamMembers extends BaseApiClient {
  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<TeamData>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/team-members', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async create(data: Partial<TeamMemberDataPost>): Promise<TeamData> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/team-members', data)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data ?? res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async update(
    userId: number | string,
    data: Partial<TeamMemberDataPost>
  ): Promise<TeamData> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/team-members/${userId}`, data)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data ?? res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async destroy(userId: number | string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/team-members/${userId}`)
        .then((res) => {
          if (res.status === 204) {
            resolve();
          } else {
            reject('Invalid response');
          }
        })
        .catch(reject);
    });
  }
}

export { teamMembersQueryKeys } from './query-keys';
export type { TeamMembersListQueryParams } from './query-keys';
export { useTeamMembersListQuery } from './use-team-members-queries';
export {
  useTeamMembersCreateMutation,
  useTeamMembersUpdateMutation,
  useTeamMembersDestroyMutation
} from './use-team-members-mutations';
export type { TeamMembersUpdateVariables } from './use-team-members-mutations';
